import * as React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import Splash from '../screens/splash';
import Login from '../screens/login';
import OTPscreen from '../screens/otp';
import Register1 from '../screens/register1';
import Home from '../screens/home';
import Order from '../screens/order';
import Chat from '../screens/chat';
import Form from '../screens/form';
import Searching from '../screens/searching';
import List from '../screens/list';
import Service from '../screens/service';
import Final from '../screens/final';
import Orderlist from '../screens/orderlist';
import Profile from '../screens/profile';
import Register2 from '../screens/register2';
import Mdfwhite from '../screens/mdfwhite';
import OrderColor from '../screens/ordercolor';
import DetailsService from '../screens/detailsService';
import WEB from '../screens/web';
import Ticket from '../screens/ticket';
import ChatTicket from '../screens/chatticket';
import Wallet from '../screens/wallet';
import WalletCode from '../screens/walletcode';











const MainNavigate = (props) => {
  const Stack = createNativeStackNavigator();


  return (

   
    <Stack.Navigator initialRouteName="splash">
      <Stack.Screen name="splash" component={Splash} options={{ headerShown: false }} />
      <Stack.Screen name="login" component={Login} options={{ headerShown: false }} />
      <Stack.Screen name="otp" component={OTPscreen} options={{ headerShown: false }} />
      <Stack.Screen name="register1" component={Register1} options={{ headerShown: false }} />
      <Stack.Screen name="register2" component={Register2} options={{ headerShown: false }} />
      <Stack.Screen name="home" component={Home} options={{ headerShown: false }} />
      <Stack.Screen name="web" component={WEB} options={{ headerShown: false }} />
      <Stack.Screen name="ticket" component={Ticket} options={{ headerShown: false }} />
      <Stack.Screen name="order" component={Order} options={{ headerShown: false }} />
      <Stack.Screen name="ordercolor" component={OrderColor} options={{ headerShown: false }} />
      <Stack.Screen name="chat" component={Chat} options={{ headerShown: false }} />
      <Stack.Screen name="chatticket" component={ChatTicket} options={{ headerShown: false }} />
      <Stack.Screen name="form" component={Form} options={{ headerShown: false }} />
      <Stack.Screen name="searching" component={Searching} options={{ headerShown: false }} />
      <Stack.Screen name="list" component={List} options={{ headerShown: false }} />
      <Stack.Screen name="service" component={Service} options={{ headerShown: false }} />
      <Stack.Screen name="detailsService" component={DetailsService} options={{ headerShown: false }} />
       <Stack.Screen name="final" component={Final} options={{ headerShown: false }} />
      <Stack.Screen name="orderlist" component={Orderlist} options={{ headerShown: false }} />
      <Stack.Screen name="profile" component={Profile} options={{ headerShown: false }} />
      <Stack.Screen name="mdfwhite" component={Mdfwhite} options={{ headerShown: false }} />
      <Stack.Screen name="wallet" component={Wallet} options={{ headerShown: false }} />
      <Stack.Screen name="walletCode" component={WalletCode} options={{ headerShown: false }} />
    </Stack.Navigator>

  );

}
export default MainNavigate